<template>
	<div id="Warehouse">
		<div class="Warehouse-box">
			<div class="Warehouse-nav">
				<div class="left-page">
					<div class="item" @click="GetGoodsList" :class="{ 'active': SwitchState == true }">
						<p>
							<img v-if="SwitchState == true" src="@/assets/images/bag/bag-s.png" alt="">
							<img v-else src="@/assets/images/bag/bag-n.png" alt="">
							背包
						</p>
						<i></i>
					</div>
					<div class="item" @click="GetExtractList" :class="{ 'active': SwitchState == false }">
						<p>
							<img v-if="SwitchState == false" src="@/assets/images/bag/get-s.png" alt="">
							<img v-else src="@/assets/images/bag/get-n.png" alt="">
							提货列表
						</p>
						<i></i>
					</div>
				</div>
				<div class="right-page" v-show="SwitchState == true">
					<p style="font-family:'Oxanium'; margin-right: 20px; color:slategray;">选中饰品价值:{{allBean}}</p>

					<div class="btn" @click="SelectAll">
						<p>全选</p>
					</div>
					<div class="btn" @click="WholeExtract">
						<p>提货</p>
					</div>
					<div class="btn" @click="WholeCash">
						<p>放弃</p>
					</div>
				</div>
			</div>

			<div class="ExtractList" v-show="SwitchState == false">
				<van-loading class="vant-load WD650" v-show="PickShow == true" color="#ffffff" size="60" />
				<div class="ExtractList-List" v-show="PickShow == false">

					<template v-if="TakingLists.length != 0">
						<div class="ExtractList-List-item" v-for="(item, index) in TakingLists" :key="index"
							:class="item.lv | LvGuoLv">
							<div class="MBX">
								<p><img src="@/assets/images/PublicImg/JinBi.png" alt="">{{ item.bean }}</p>
								<span>{{ item.dura_alias }}</span>
							</div>
							<div class="pic">
								<img v-lazy="item.cover" alt="">
							</div>
							<div class="name">
								{{ item.name }}
							</div>
							<div class="btn">
								<p :style="{ 'color': item.status == '1' ? '#77b300' : 'red' }">{{ item.status_alias }}</p>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="empty_data">
							<p>暂无数据</p>
						</div>
					</template>

				</div>

				<div class="PageNum" :key="this.PickCode">
					<el-pagination background layout="prev, pager, next" @current-change="PickChange"
						:page-size="TakingListper_page" :total="TakingListPageNum">
					</el-pagination>
				</div>
			</div>


			<div class="GoodsList" v-show="SwitchState == true">
				<van-loading class="vant-load WD650" v-show="loadingShow == true" color="#ffffff" size="60" />
				<div class="Warehouse-List" v-show="loadingShow == false">
					<template v-if="WarehouseLists.length != 0">
						<div class="Warehouse-List-item" v-for="(item, index) in WarehouseLists" :key="index" ref="Select"
							:class="item.lv | LvGuoLv">
							<div class="MBX">
								<p><img src="@/assets/images/PublicImg/JinBi.png" alt="">{{ item.bean }}</p>
								<span>{{ item.dura_alias }}</span>
							</div>
							<div class="pic" @click="Select(item, index)">
								<img v-lazy="item.cover" alt="">
							</div>
							<div class="name">
								{{ item.name }}
							</div>
						</div>
					</template>
					<template v-else>
						<div class="empty_data">
							<p>暂无数据</p>
						</div>
					</template>
				</div>

				<div class="PageNum">
					<el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
						:page-size="per_page" :total="PageNum">
					</el-pagination>
				</div>
			</div>

			<van-overlay :show="GiveShow">
				<div class="wrapper">
					<div class="wrapper-box">
						<div class="wrapper-box-top"></div>
						<div class="cancel">
							<img src="@/assets/images/PublicImg/GuanBi.png" alt="" @click="CloseGiveShow">
						</div>
						<div class="tit">赠送好友</div>
						<div class="pic">
							<img :src="GiveImg" alt="">
						</div>
						<form>
							<div class="other">
								<p>请输入对方邀请码</p>
								<input type="text" v-model="Invitation_code">
							</div>
						</form>
						<div class="btns">
							<span @click="CloseGiveShow">取消赠送</span>
							<span class="btn-two" @click="GetGive">确定赠送</span>
						</div>
					</div>
				</div>
			</van-overlay>
		</div>
	</div>
</template>

<script>
import {
	Storage,
	Extract,
	Cash,
	Give,
	PersonalInfo
} from '@/network/api.js'
import {
	mapMutations
} from 'vuex'
export default {
	name: '',
	data() {
		return {
			WarehouseLists: [],
			loadingShow: true,
			PageNum: 0,
			Select_All: false,
			GiveShow: false,
			GiveImg: null,
			GiveId: '',
			Invitation_code: '',
			per_page: 10,
			page_Num: 1,
			allBean:0.00,

			TakeOption: [{
				text: '申请提货',
				value: 4
			}, {
				text: '正在发货',
				value: 5
			}, {
				text: '等待收货',
				value: 6
			}, {
				text: '提货完成',
				value: 1
			}],
			TakeValue: 4,

			SwitchState: true,

			TakingLists: [],
			TakingListPageNum: 0,
			TakingListper_page: 0,

			PickSwitch: 1,

			PickCode: '4',
			PickShow: true

		}
	},

	created() {
		this.GetStorage(1);
	},
	activated() {

	},
	filters: {
		LvGuoLv(val) {
			if (val == '1') {
				return 'lv1'
			} else if (val == '2') {
				return 'lv2'
			} else if (val == '3') {
				return 'lv3'
			} else if (val == '4') {
				return 'lv4'
			} else if (val == '5') {
				return 'lv5'
			}
		},
	},

	methods: {
		GetGoodsList() {
			this.loadingShow = true
			this.SwitchState = true
			this.GetStorage(1)
		},

		GetExtractList() {
			this.SwitchState = false
			this.PickSwitch = 4
			this.GetTakingList(1, 4)
		},


		PickTHZ(num) {
			this.PickShow = true
			this.PickSwitch = num
			this.PickCode = num
			this.GetTakingList(1, num)
		},

		GetTakingList(num, code) {
			Storage(num, code).then((res) => {
				this.TakingLists = res.data.data.data
				this.TakingListPageNum = Number(res.data.data.total)
				this.TakingListper_page = Number(res.data.data.per_page)
			})
		},

		PickChange(val) {
			this.PickShow = true
			this.GetTakingList(val, this.PickCode)
		},

		GetStorage(num) {
			this.loadingShow = true
			Storage(num).then((res) => {
				if (res.data.data.data.length > 0) {
					this.WarehouseLists = res.data.data.data
					this.PageNum = Number(res.data.data.total)
					this.per_page = Number(res.data.data.per_page)
				} else {
					if (num == '1') {
						this.WarehouseLists = res.data.data.data
						this.PageNum = Number(res.data.data.total)
						this.per_page = Number(res.data.data.per_page)
						this.loadingShow = false
					} else {
						this.GetStorage('1')
					}

				}


			})
		},

		handleCurrentChange(val) {
			this.GetStorage(val)
			this.page_Num = val
		},

		OpenGetGive(item) {
			this.GiveImg = item.cover
			this.GiveId = item.id
			this.GiveShow = true
		},

		GetGive() {
			Give(this.GiveId, this.Invitation_code).then((res) => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success'
					})
					this.GiveShow = false
					this.GetStorage(this.page_Num)

				}
			})
		},

		CloseGiveShow() {
			this.GiveImg = null
			this.GiveId = ''
			this.GiveShow = false
		},


		WholeExtract() {
			let arr = this.WarehouseLists.filter((item) => {
				return item.Select == true
			})

			let data = []
			for (let i = 0; i < arr.length; i++) {
				data.push({
					"id": arr[i].id
				})
			}
			Extract(JSON.stringify(data)).then((res) => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success'
					})
					this.GetStorage(this.page_Num)
					this.GetPersonalInfo()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
			})
		},


		GetCash(id) {
			let data = [{
				"id": id
			}]
			Cash(JSON.stringify(data)).then((res) => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success'
					})
					this.GetPersonalInfo()
					this.GetStorage(this.page_Num)
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
			})
		},

		WholeCash() {
			let arr = this.WarehouseLists.filter((item) => {
				return item.Select == true
			})

			let data = []
			for (let i = 0; i < arr.length; i++) {
				data.push({
					"id": arr[i].id
				})
			}
			Cash(JSON.stringify(data)).then((res) => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success'
					})
					this.GetPersonalInfo()
					this.GetStorage(this.page_Num)
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
			})
		},

		Select(item, index) {
			if (item.Select) {
				delete item.Select
				this.$refs.Select[index].style.border = "1px solid #1b1f36";
			} else {
				let key = "Select";
				let value = true
				item[key] = value
				this.$refs.Select[index].style.border = "1px solid #E9B10E"
			}
			this.test();
		},

		SelectAll() {
			if (this.Select_All == false) {
				for (let i = 0; i < this.WarehouseLists.length; i++) {
					let key = "Select";
					let value = true
					this.WarehouseLists[i][key] = value
					this.$refs.Select[i].style.border = "1px solid #E9B10E"
				}
				this.Select_All = true

			} else {
				for (let i = 0; i < this.WarehouseLists.length; i++) {
					delete this.WarehouseLists[i].Select
					this.$refs.Select[i].style.border = "1px solid #1b1f36"
				}
				this.Select_All = false
			}

			this.test();
		},

		test(){
			this.allBean = 0.00;
			for (let i = 0; i < this.WarehouseLists.length; i++) {
				if(this.WarehouseLists[i].Select){
					this.allBean += Number(this.WarehouseLists[i].bean);
				}
			}


			this.allBean = this.allBean.toFixed(2);

		},




		GetPersonalInfo() {
			PersonalInfo().then((res) => {
				this.User(res.data.message)
			})
		},


		...mapMutations([
			'User'
		])

	},

	watch: {
		WarehouseLists(val) {
			for (let i = 0; i < this.WarehouseLists.length; i++) {
				delete this.WarehouseLists[i].Select
				setTimeout(() => {
					if (this.$refs.Select) {
						this.$refs.Select[i].style.border = "1px solid #1b1f36"
					}
					this.loadingShow = false
				}, 100)
			}
			this.Select_All = false
		},

		TakingLists(val) {
			this.PickShow = false
		},

		TakeValue(v) {
			this.PickCode = String(v)
			this.GetTakingList(1, String(v))
		}
	}
}
</script>

<style lang="scss">
.Warehouse-box {
	width: 100%;
	.empty_data {
		user-select:none;
		width: 100%;
		min-height: 550px;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		align-items: center;
		padding-top: 20px;

		p {
			width: 502px;
			height: 16px;
			font-size: 16px;
			color: #4c4f53;
			text-align: center;
			white-space: nowrap;
		}
	}

	.Warehouse-nav {
        width: 100%;
		background-color: #11131D;
		display: flex;
		justify-content: space-between;
		user-select:none;
		.left-page {
			display: flex;
			box-sizing: border-box;
			align-items: center;

			.item {
				width: 220px;
				height: 80px;
				box-sizing: border-box;
				text-align: center;
				cursor: pointer;
				position: relative;
				display: flex;
				justify-content: center;

				p {
					color: #FFFFFF;
					font-size: 14px;
					display: flex;
					align-items: center;

					& img {
						width: 20px;
						margin-right: 1px;
					}
				}

				i {
					display: block;
					width: 100%;
					height:2px;
					position: absolute;
					background: #91743e;
					left: 50%;
					bottom: 0;
					transform: translateX(-50%);
                    opacity: 0;
				}

				&:hover {
					background: rgba($color: #ffa07a, $alpha: .03);
				}

				&.active {
					background: rgba($color: #fff, $alpha: .03);

					i {
						opacity: 1;
					}
				}
			}
		}

		.right-page {
			display: flex;
			align-items: center;

			.btn {
				width: 80px;
				height: 32px;
				cursor: pointer;
				display: flex;
				justify-content: center;
				align-items: center;
				color: #ffffff;
				background-image: linear-gradient(90deg, #6f5a39, #6f4c2c);
				background-blend-mode: normal, normal;
				border-radius: 4px;
				border: 1px solid #dcae64;
				user-select: none;
				transition: all .3s ease;
				margin-right: 15px;

				&:hover {
					background-image: linear-gradient(90deg, #6f5a39, #47321d);
				}

				p {
					font-size: 14px;
				}

			}
		}

	}

	
	.WD650 {
		width: 100%;
		height: 7.28rem;
		text-align: center;
		line-height: 7.3rem;
	}

	.PageNum {
		width: 100%;
		text-align: center;

		li {
			background: #111111 !important;

			&.active {
				background: #4854c9 !important;
			}

			&:hover {
				color: #fff !important;
			}
		}

		.btn-prev,
		.btn-next {
			background: #111111;
		}
	}

	.ExtractList {
		width: 100%;
		min-height: 550px;
		.ExtractList-List {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			margin-top: 10px;

			.ExtractList-List-item {
                width: 225px;
                margin: 4px;
                text-align: center;
                background: url(../../assets/images/Roll/LV1.png) no-repeat center;
                background-size: 100% 100%;
				cursor: pointer;

				&:hover {
					box-shadow: #E9B10E 0rem 0rem 4px;
				}

				&.lv1 {
					background: url(../../assets/images/Roll/LV1.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv2 {
					background: url(../../assets/images/Roll/LV2.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv3 {
					background: url(../../assets/images/Roll/LV2.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv4 {
					background: url(../../assets/images/Roll/LV3.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv5 {
					background: url(../../assets/images/Roll/LV3.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.active {
					border: 1px solid red;
				}

				.MBX {
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 15px;
                    box-sizing: border-box;

					p {
						font-size: 15px;
						color: #FFD077;
						display: flex;
						align-items: center;
                        font-family: 'Oxanium';
						img {
                            width: 20px;
                            height: 20px;
                            vertical-align: middle;
                            margin: 0 1px 2px 0;
						}
					}

					span {
						font-size: 14px;
						color: #808FA4;
						border: none;
					}
				}

				.pic {
                    width: 150px;
                    height: 150px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    img {
                        max-width: 100%;
                        max-height: 100%;
				    }
				}

				.name {
					width: 100%;
                    font-size:14px;
                    margin-bottom: 10px;
				}

				.btn {
					width: 100%;
					height: 40px;
					border-top: 1px solid #332f2f;
					text-align: center;

					p {
						line-height: 40px;
						font-size: 14px;
					}
				}
			}
		}
	}

	.GoodsList {
		width: 100%;
		min-height: 550px;

		.Warehouse-List {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			margin-top: 10px;

			.Warehouse-List-item {
                width: 225px;
                margin: 4px;
                text-align: center;
                background: url(../../assets/images/Roll/LV1.png) no-repeat center;
                background-size: 100% 100%;
				cursor: pointer;

				&:hover {
					box-shadow: #E9B10E 0rem 0rem 4px;
				}

				&.lv1 {
					background: url(../../assets/images/Roll/LV1.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv2 {
					background: url(../../assets/images/Roll/LV2.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv3 {
					background: url(../../assets/images/Roll/LV2.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv4 {
					background: url(../../assets/images/Roll/LV3.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv5 {
					background: url(../../assets/images/Roll/LV3.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.active {
					border: 1px solid red;
				}

				.MBX {
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 15px;
                    box-sizing: border-box;

					p {
						font-size: 15px;
						color: #FFD077;
						display: flex;
						align-items: center;
                        font-family: 'Oxanium';
						img {
                            width: 20px;
                            height: 20px;
                            vertical-align: middle;
                            margin: 0 1px 2px 0;
						}

						span {
							color: #fff;
							margin: 0;
						}
					}

					span {
						font-size: 14px;
						color: #808FA4;
						border: none;
						margin: 0;
					}
				}

				.pic {
                    width: 150px;
                    height: 150px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    img {
                        max-width: 100%;
                        max-height: 100%;
				    }
				}

				.name {
					width: 100%;
                    font-size:14px;
                    margin-bottom: 10px;
				}

			}
		}
	}

	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;

		.wrapper-box {
			z-index: 2001;

			.wrapper-box-top {
				width: 100%;
				height: 0.03rem;
				background: linear-gradient(90deg, transparent, rgba(72, 84, 201, 0.8), transparent);
			}

			width: 5rem;
			height: 5.5rem;
			position: relative;
			border: 1px solid #4854c9;
			background-color: #1e2355;
			border-radius: 0.08rem;
			overflow: hidden;
			padding: 0 0.35rem;
			box-sizing: border-box;

			.tit {
				width: 100%;
				font-size: 0.24rem;
				text-align: center;
				line-height: 0.8rem;
			}

			.other {
				width: 100%;
				height: 0.5rem;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 0.2rem;

				p {
					font-size: 0.18rem;
					margin-right: 0.2rem;
				}

				input {
					height: 0.4rem;
					width: 1rem;
					background: rgba(255, 255, 255, 0.06);
					border: 1px solid rgba(255, 255, 255, 0.6);
					color: #e52131;
					border-radius: 0.04rem;
					line-height: 0.4rem;
					text-align: center;
					font-size: 0.18rem;
				}
			}

			.pic {
				width: 2.75rem;
				height: 2.75rem;
				margin: 0 auto;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 0.04rem;
				overflow: hidden;

				img {
					max-width: 80%;
					max-height: 80%;
				}
			}

			.btns {
				width: 100%;
				height: 0.5rem;
				display: flex;
				justify-content: center;
				margin-top: 0.2rem;

				span {
					display: block;
					width: 1.65rem;
					height: 0.5rem;
					background: hsla(0, 0%, 100%, .06);
					border: 1px solid hsla(0, 0%, 100%, .2);
					color: #e4e4e4;
					border-radius: 0.04rem;
					text-align: center;
					line-height: 0.5rem;
					font-size: 0.14rem;
					margin-right: 0.2rem;
					cursor: pointer;
				}

				.btn-two {
					margin-right: 0;
					background: #4854c9;
					border-color: #4854c9;
				}
			}

			.info {
				margin-top: 0.3rem;
				text-align: center;
				font-size: 0.12rem;
				color: rgba(255, 255, 255, 0.53);
			}

			.cancel {
				width: 0.5rem;
				height: 0.5rem;
				position: absolute;
				top: 0;
				right: 0;
				text-align: center;
				line-height: 0.5rem;

				img {
					width: 0.15rem;
					cursor: pointer;
				}
			}
		}
	}
}</style>
